import { createContext } from 'react';

import { ContextType } from './types';

export default createContext<ContextType>({
  getRegion: () => null,
  setRegion: () => {},
});
